/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
      <v-card style="margin:auto;" width="1400" >
    <v-card-title style="background-color:#006699;color:white;"></v-card-title>
 <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- =========================== DIALOGO DE DETALHES ============================================== -->
              <template>
  <v-row justify="center">
    <v-dialog v-model="dialog_detalhes" persistent max-width="1000px">
      <v-card>
        <v-card-title style="background-color:#006699;color:white;" >
          <span class="headline">Detalhes do Produto</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <template>
                    <v-card>
                      <v-tabs
                        v-model="tab"
                        color="#006699"
                      >
                        <v-tab
                          v-for="item in tabsItems"
                          :key="item.tab"
                        >
                          {{ item.tab }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                   <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Código de Barra : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.codigoBarra}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Nome do Produto : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.produto}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Categoria : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.familia}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Descrição Reduzida : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.descricaoReduzida}}</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Cadastrado em : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.data_cadastro}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                  <v-col v-if="editedItem.precoVendaDefinido !== 2" cols="12" sm="6" md="12">
                                    <span  style="color:red;font-weight:bold;font-size:15px;">Preço de Venda não definido</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span v-if="editedItem.iva === 14" style="color:#006699;font-weight:bold;font-size:15px;">Preço de Venda( IVA incluido ) : </span><span v-if="editedItem.iva === 14" style="font-size:15px;font-weight:bold;">{{ utilitarios.IntegerToMoneyValue(editedItem.precoComIva)}}</span>
                                    <span v-if="editedItem.iva !== 14" style="color:#006699;font-weight:bold;font-size:15px;">Preço de Venda: </span><span v-if="editedItem.iva !== 14" style="font-size:15px;font-weight:bold;">{{ utilitarios.IntegerToMoneyValue(editedItem.precoComIva)}}</span>
                                  </v-col>
                                  <v-col v-if="editedItem.iva === 14" cols="12" sm="6" md="12">
                                     <span v-if="editedItem.iva === 14" style="color:#006699;font-weight:bold;font-size:15px;">Preço sem Iva: </span><span v-if="editedItem.iva === 14" style="font-size:15px;font-weight:bold;">{{ utilitarios.IntegerToMoneyValue(editedItem.precoSemIva)}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">IVA: </span><span style="font-size:15px;font-weight:bold;">{{editedItem.iva}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Descrição Reduzida : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.descricaoReduzida}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                  <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Controle de Stock : </span><v-icon style="font-size:20px;color:green;" v-if="editedItem.controleStock === 2">done</v-icon><v-icon style="font-size:20px;color:red;" v-if="editedItem.controleStock !== 2">clear</v-icon>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Stock Minimo : </span><span   style="font-size:15px;font-weight:bold;">{{(editedItem.controleStock !== 2)?' ---':editedItem.stock_min}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span   style="color:#006699;font-weight:bold;font-size:15px;">Stock Máximo: </span><span   style="font-size:15px;font-weight:bold;">{{ (editedItem.controleStock !== 2)?' ---':editedItem.stock_max}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span  style="color:#006699;font-weight:bold;font-size:15px;">Stock Existente: </span><span   style="font-size:15px;font-weight:bold;">{{ editedItem.entrada_stk}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                  <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Quantidade Entrada : </span><span>{{(dados_contaCorrente.length && dados_contaCorrente[0].entrada !== null)?dados_contaCorrente[0].entrada : 0}}</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Quantidade Saida : </span><span   style="font-size:15px;font-weight:bold;">{{(dados_contaCorrente_saidas.length && dados_contaCorrente_saidas[0].saida !== null)?dados_contaCorrente_saidas[0].saida : 0}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span   style="color:#006699;font-weight:bold;font-size:15px;">Total de entradas(em dinheiro): </span><span   style="font-size:15px;font-weight:bold;">{{(dados_contaCorrente.length && dados_contaCorrente[0].entrada_dinheiro !== null) ? utilitarios.IntegerToMoneyValue(dados_contaCorrente[0].entrada_dinheiro) : utilitarios.IntegerToMoneyValue(0)}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span  style="color:#006699;font-weight:bold;font-size:15px;">Total de saidas(em dinheiro): </span><span   style="font-size:15px;font-weight:bold;">{{(dados_contaCorrente_saidas.length && dados_contaCorrente_saidas[0].saida_dinheiro !== null) ? utilitarios.IntegerToMoneyValue(dados_contaCorrente_saidas[0].saida_dinheiro) : utilitarios.IntegerToMoneyValue(0)}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text"   @click="dialog_detalhes = false" col>Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </template>
    <!-- ========================================================================================================================================== -->

    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
      <v-row>
         <v-col md="1"><span>Produto:</span></v-col>
         <v-col md="3"><span style="font-weight:bold;">Aspirina</span></v-col>
      </v-row>
       <v-card-title>
        <span>Clientes por Produto</span>
         <v-spacer></v-spacer>
         <v-row style="height:100px;float:right;">
            <div style="padding:20px;float:right;margin-left:1050px;">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn fab
                    v-bind="attrs"
                    v-on="on"
                    color="white" >
                    <img width="30px" src="../../../assets/pdf_exibir.png">
                    </v-btn>
                </template>
                <span>Clique aqui para exportar os dados em PDF.</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    fab
                    v-bind="attrs"
                    v-on="on"
                    color="white"
                    >
                    <img width="30px" src="../../../assets/download.png">
                    </v-btn>
                </template>
                <span>Clique aqui para exportar os dados em Excel.</span>
            </v-tooltip>
            </div>
         </v-row>
      </v-card-title>
        <template>
          <v-data-table :search="search" :headers="headers" :items="produtos">
          <template v-slot:item.precoSemIva="{ item }">
              <span >{{ObterValorFormatado(item.precoSemIva)+ ' Akz'}}</span>
          </template>
          <template v-slot:item.iva="{ item }">
              <span >{{ item.iva + ' %'}}</span>
          </template>
           <template v-slot:item.precoComIva="{ item }">
              <span >{{ObterValorFormatado(item.precoComIva)+ ' Akz'}}</span>
          </template>
           <template v-slot:item.unidade="{ item }">
              <span v-if="item.unidade === 1" >unidade</span>
              <span v-if="item.unidade === 2">Kg</span>
          </template>
           <template v-slot:item.status="{ item }">
             <span v-if="item.stock_min === null||item.stock_max === null">Sem controle de Stock</span>
              <v-icon v-if="(item.stock_min !== null||item.stock_max !== null)&&(item.entrada_stk <= item.stock_min)" style="color:red;" >fiber_manual_record</v-icon>
              <v-icon v-if="((item.stock_min !== null||item.stock_max !== null)&&(item.entrada_stk <= (item.stock_max/2)) && item.entrada_stk > item.stock_min ) " style="color:orange;" >fiber_manual_record</v-icon>
              <v-icon v-if="(item.stock_min !== null||item.stock_max !== null)&&(item.entrada_stk >= (item.stock_max/2))" style="color:green;" >fiber_manual_record</v-icon>
          </template>
           <template v-slot:item.action="{ item }">
                  <v-menu
                    :offset-x="offsetX"
                    :offset-y="offsetY"
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab dark small
                       color="#006699"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>menu</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                       <v-list-item @click="movimentacoes(item)">
                        <v-icon color="green" >swap_horiz</v-icon>Movimentações por Clientes
                      </v-list-item>
                    </v-list>
                  </v-menu>
              </template>
          </v-data-table>
        </template>
        <hr>
            <template  >
              <v-row>
                 <v-col md="4">
                    <span style="margin-left:54px;font-size:18px;font-weight:bold;">Nº de Produtos: <v-chip>{{produtos.length}}</v-chip></span>
                 </v-col>
                 <v-col md="4">
                 </v-col>
                 <v-col md="4">
                    <span>Existências: <v-chip>{{totalExistencias}} </v-chip></span>
                 </v-col>
              </v-row>

            </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>
import axios from '../../../plugins/axios'
import utilitarios from '../../../plugins/utilitarios'
export default {
  data: () => ({
    produtos: [],
    progresso: false,
    offsetX: false,
    offsetY: true,
    overlay: false,
    tab: null,
    utilitarios: utilitarios,
    dialog_detalhes: false,
    dados_contaCorrente: [],
    dados_contaCorrente_saidas: [],
    search: '',
    headers: [
      {
        text: 'Cliente',
        align: 'start',
        sortable: false,
        value: 'produto'
      },
      { text: 'Data', value: 'codigoBarra' },
      { text: 'Movimento', value: 'unidade' },
      { text: 'Quantidade', value: 'unidade' },
      { text: 'Valor Unitário', value: 'unidade' },
      { text: 'Ações', value: 'action' }
    ],
    tabsItems:
    [
      { id: 1, tab: 'Geral' },
      { id: 2, tab: 'Preços' },
      { id: 3, tab: 'Estoque' },
      { id: 3, tab: 'Conta Corrente do Produto' }
    ],
    editedItem:
     {
       armazem: '',
       codigoBarra: '',
       descricaoPreco: '',
       descricaoReduzida: '',
       entrada_stk: 0,
       especificacaoProduto: '',
       familia: '',
       isencao: '',
       iva: 0,
       margem: 0,
       mercadoria: '',
       pkArmazem: 0,
       pkFamilia: 0,
       pkProduto: 0,
       precoComIva: 0,
       precoSemIva: 0,
       produto: '',
       stock_max: null,
       stock_min: null,
       tipoProduto: 0,
       unidade: 0,
       controleStock: 0,
       precoVendaDefinido: 0,
       calculoPrecoVenda: 0
     }
  }),
  computed: {
    totalExistencias () {
      let total = 0
      this.produtos.forEach(element => {
        total += parseInt(element.entrada_stk)
      })
      return total
    }
  },

  created () {
    this.InitializeProdutos()
  },

  methods: {
    async  InitializeProdutos () {
      try {
        //   let  payload =""
        this.progresso = true
        this.produtos = await axios
          .get('/clientesPorProduto')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  CarregaDadosConta (fkProduto) {
      try {
        //   let  payload =""
        this.overlay = true
        this.dados_contaCorrente = await axios
          .get('/ContaCorrente-entradas/' + fkProduto)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  CarregaDadosConta_saidas (fkProduto) {
      try {
        //   let  payload =""
        this.overlay = true
        this.dados_contaCorrente_saidas = await axios
          .get('/ContaCorrente-saidas/' + fkProduto)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    movimentacoes (item) {
      this.$store.state.produtoDetalhe = item
      this.$router.push('detalhes-movimentacao')
    },
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },

    EditarProduto (item) {
      this.$store.state.produto = item
      this.$router.push('/Editar-Produto')
    },
    detalhes (item) {
      this.editedItem = Object.assign(this.editedItem, item)
      this.CarregaDadosConta(this.editedItem.pkProduto).then(() => {
        this.CarregaDadosConta_saidas(this.editedItem.pkProduto).then(() => {
          this.dialog_detalhes = true
        })
      })
    }

  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}
</style>
